export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];
export const listTitle = [
    {
        title: 'SkillsTeam\n' + '&mdash;российская система управления грейдами',
        subtitle: `Создали систему управления матрицами компетенций и&nbsp;индивидуальных
         траекторий развития сотрудников. Продукт позволяет выстраивать
          прозрачные карьерные траектории, упрощает процесс оценки
           и&nbsp;помогает сотрудникам расти профессионально.
            Создали и&nbsp;запустили консалтинг от&nbsp;методистов
             по&nbsp;работе с&nbsp;матрицами компетенций.`,
        description: [
            {
                name: 'Отрасль',
                details: 'HRTech',
            },
            {
                name: 'Услуги',
                details: 'Разработка платформы',
            },
            {
                name: 'Сроки',
                details: 'январь 2024 – июнь 2024',
            },
        ],
        company: 'SkillsTeam',
        companyLink: 'https://skillsteam.pro/',
        companyLinkName: 'skillsteam.pro',
        text:
            'Российская система управления грейдами и&nbsp;матрицами компетенций.' +
            ' Это инструмент, позволяющий компаниям управлять движением сотрудников' +
            ' по&nbsp;грейдам, поддерживать актуальные данные' +
            ' о&nbsp;компетенциях и&nbsp;карьерных траекториях.',
    },
];

export const targetList = {
    title: 'Цель',
    description: 'Оцифровка лучших практик управления карьерными траекториями.',
};
export const listFrontend = [
    {
        icon: '/images/svg/skills-team/kuber.svg',
        text: 'Kubernetes',
    },
    {
        icon: '/images/svg/skills-team/post.svg',
        text: 'Postgresql',
    },
    {
        icon: '/images/svg/skills-team/next14.svg',
        text: 'Next.js',
    },
    {
        icon: '/images/svg/skills-team/docker.svg',
        text: 'Docker',
    },
];

export const listMatrixe = [
    {
        title: 'Frontend-разработчик',
        subtitle: `Разработка`,
        description: [
            {
                number: '92',
                name: 'подробно описанных скила',
            },
            {
                number: '9',
                name: 'грейдов от&nbsp;junior-1 до&nbsp;senior-2',
            },
        ],
        icon: '/images/pic/skills-team/m1.png',
    },
    {
        title: 'Инженер по тестированию',
        subtitle: `Разработка`,
        description: [
            {
                number: '75',
                name: 'подробно описанных скила',
            },
            {
                number: '4',
                name: 'грейда от&nbsp;trainee до&nbsp;senior',
            },
        ],
        icon: '/images/pic/skills-team/m2.png',
    },
    {
        title: 'Аналитик',
        subtitle: `Разработка`,
        description: [
            {
                number: '43',
                name: 'подробно описанных скила',
            },
            {
                number: '3',
                name: 'грейда от&nbsp;junior до&nbsp;senior',
            },
        ],
        icon: '/images/pic/skills-team/m3.png',
    },
    {
        title: 'PHP-разработчик',
        subtitle: `Разработка`,
        description: [
            {
                number: '103',
                name: 'подробно описанных скила',
            },
            {
                number: '3',
                name: 'грейда от&nbsp;junior до&nbsp;senior',
            },
        ],
        icon: '/images/pic/skills-team/m4.png',
    },
    {
        title: 'UX/UI дизайнер',
        subtitle: `Разработка`,
        description: [
            {
                number: '120',
                name: 'подробно описанных скила',
            },
            {
                number: '9',
                name: 'грейдов от&nbsp;junior-1 до&nbsp;senior-2',
            },
        ],
        icon: '/images/pic/skills-team/m5.png',
    },
    {
        title: 'Специалист по платному трафику',
        subtitle: `Маркетинг`,
        description: [
            {
                number: '92',
                name: 'подробно описанных скила',
            },
            {
                number: '9',
                name: 'грейдов от&nbsp;junior-1 до&nbsp;senior-2',
            },
        ],
        icon: '/images/pic/skills-team/m6.png',
    },
    {
        title: 'SEO',
        subtitle: `Маркетинг`,
        description: [
            {
                number: '158',
                name: 'подробно описанных скила',
            },
            {
                number: '7',
                name: 'грейдов от&nbsp;prejunior до&nbsp;senior',
            },
        ],
        icon: '/images/pic/skills-team/m7.png',
    },
    {
        title: 'Менеджер диджитал проектов',
        subtitle: `Маркетинг`,
        description: [
            {
                number: '107',
                name: 'подробно описанных скила',
            },
            {
                number: '8',
                name: 'грейдов от&nbsp;prejunior до&nbsp;senior',
            },
        ],
        icon: '/images/pic/skills-team/m8.png',
    },
];

export const listBusiness = [
    {
        title: 'Оптимизация онбординга и&nbsp;аттестации',
        text:
            'Можно установить общие стандарты для разных внутренних' +
            ' HR-процессов и&nbsp;включить любые элементы в&nbsp;план' +
            ' развития сотрудника, которые необходимы компании' +
            ' с&nbsp;учетом ее&nbsp;бизнес-целей.',
    },
    {
        title: 'Управление карьерными траекториями',
        text:
            'Система помогает определить сильные и&nbsp;слабые стороны' +
            ' сотрудников, что позволяет адаптировать программы' +
            ' развития под цели компании и&nbsp;индивидуальные потребности.',
    },
    {
        title: 'Повышение мотивации сотрудников',
        text:
            'На&nbsp;платформе есть инструменты для анализа' +
            ' прогресса, что позволяет руководителям принимать' +
            ' обоснованные карьерные решения.',
    },
    {
        title: 'Поддержка культуры обучения и&nbsp;развития',
        text:
            'SkillsTeam помогает бесшовно внедрить культуру постоянного' +
            ' развития, которая влияет на&nbsp;рост общей' +
            ' производительности команд.',
    },
    {
        title: 'Автоматизация оценки',
        text:
            'Инструменты платформы позволяют быстро и&nbsp;точно' +
            ' оценивать навыки и&nbsp;компетенции сотрудников' +
            ' в&nbsp;соответствие с&nbsp;грейдами без ручного ввода данных.',
    },
    {
        title: 'Централизация данных',
        text:
            'SkillsTeam собирает и&nbsp;хранит данные о&nbsp;всех' +
            ' сотрудниках в&nbsp;одном месте, что упрощает' +
            ' доступ к&nbsp;актуальной информации.',
    },
];

export const listResults = [
    {
        title: `98 <span>компаний</span>`,
        description: 'зарегистрировались на&nbsp;платформе',
    },
    {
        title: '9 <span>матриц</span>',
        description: 'компетенций разработано',
    },
    {
        title: '850+ <span>скилов</span>',
        description: 'описаны в&nbsp;матрицах компетенций',
    },
    {
        title: '6 <span>месяцев</span>',
        description: 'срок создания MVP',
    },
    {
        title: '5 <span>человек</span>',
        description: 'команда продукта',
    },
];
